import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import LabPhilosophy from './pages/LabPhilosophy';
import People from './pages/People';
import PatientPartners from './pages/PatientPartners';
import Participate from './pages/Participate';
import Publications from './pages/Publications';
import News from './pages/News';
import Awards from './pages/Awards';
import Contact from './pages/Contact';
import './App.css';

function App() {
  return (
    <div className="app">
      <ScrollToTop />
      <Navbar />
      <main className="app-main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/lab-philosophy" element={<LabPhilosophy />} />
          <Route path="/people" element={<People />} />
          <Route path="/patient-partners" element={<PatientPartners />} />
          <Route path="/participate" element={<Participate />} />
          <Route path="/publications" element={<Publications />} />
          <Route path="/news" element={<News />} />
          <Route path="/awards" element={<Awards />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
